export default "__VITE_ASSET__C$bjzVJi__"